module.exports = __webpack_public_path__ + "static/media/warning-blue.f65fce5a.svg";